import gql from 'graphql-tag';

export const FETCH_TIMEOUT_PING = gql`
  query {
    systemConfig {
      updateAvailabilityCheckIntervalInSec
    }
  }
`;
